<div class="text-center mt-2">
    <div fxFlex.gt-sm="25"></div>
    <div fxFlex.gt-sm="50">
        <form [formGroup]="passwordResetFrom" (ngSubmit)="onResetPassword(passwordResetFrom.value)">
            <h2>Reset Password</h2>
            <mat-form-field appearance="outline" class="w-100 mt-1">
                <mat-label>Password</mat-label>
                <input matInput placeholder="Password" formControlName="password" type="password" minlength="6"
                    required>
                <mat-error *ngIf="passwordResetFrom.controls.password.errors?.required">Password is required</mat-error>
                <mat-error *ngIf="passwordResetFrom.controls.password.hasError('minlength')">Password isn't long enough,
                    minimum of 6 characters</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100 mt-1">
                <mat-label>Confirm Password</mat-label>
                <input matInput placeholder="Confirm Password" formControlName="confirmPassword" type="password"
                    required>
                <mat-error *ngIf="passwordResetFrom.controls.confirmPassword.errors?.required">Confirm Password is
                    required</mat-error>
                <mat-error *ngIf="passwordResetFrom.controls.confirmPassword.hasError('mismatchedPasswords')">Passwords
                    do not match</mat-error>
            </mat-form-field>
            <div class="text-center mt-2">
                <button mat-raised-button color="primary" class="mat-elevation-z6" type="submit">
                    <mat-label>SUBMIT</mat-label>
                </button>
            </div>
        </form>
    </div>
    <div fxFlex.gt-sm="25"></div>
</div>